import React from 'react';
import PageDetail from './PageDetail';

const DrinkDetail = (props) => {
  return <PageDetail tag='DRINKS' url='/drink-selection' id={props.match.params.id}/>;
}

export default DrinkDetail;